import { useMemo } from 'react';

import { customerInTrial, customerTrialEnded } from 'src/data/customer';
import { getCustomerPlan, isPlanFromBasicOrStarterCategory } from 'src/data/subscription';
import { useCurrentCustomer } from 'src/store';

export const useIsCustomerStarterOrTrialPlan = () => {
  const customer = useCurrentCustomer();
  const plan = getCustomerPlan(customer);

  return useMemo(
    () =>
      customerInTrial(customer) ||
      customerTrialEnded(customer) ||
      isPlanFromBasicOrStarterCategory(plan),
    [customer, plan]
  );
};
